import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { GamificationCelebrationComponent } from './gamification-celebration.component';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [
		GamificationCelebrationComponent,
	],
	imports: [
		CommonModule,
		IonicModule,
	],
	exports: [
		GamificationCelebrationComponent,
	]
})
export class GamificationCelebrationComponentModule {
	constructor() {

	}
}
